export const isValidSubject = (subject: string): boolean => {
  // INFO : There should be only 1 subject in the array
  // INFO : The length was test by sending myself an email with a subject of 3779 characters and Gmail truncated it to 998 characters.
  return typeof subject === "string" && subject.length <= 998;
};
